export default [
  {
    text: 'name',
    value: 'title',
    isDefault: true,
    isSelected: true,
    isRequired: false,
  },
  {
    text: 'platform',
    value: 'country',
    sortable: true,
    isDefault: true,
    isSelected: true,
    isRequired: false,
  },
  {
    text: 'dates',
    value: 'dates',
    sortable: false,
    isDefault: true,
    isSelected: true,
    isRequired: false,
  },
  {
    text: 'sponsorships',
    value: 'sponsorships',
    sortable: true,
    isDefault: true,
    isSelected: true,
    isRequired: false,
  },
  {
    text: 'status',
    value: 'status',
    sortable: true,
    isDefault: true,
    isSelected: true,
    isRequired: false,
  },
];
